import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold" }
const _hoisted_2 = { class: "my-4 text-center" }
const _hoisted_3 = { class: "flex justify-center gap-6 w-full" }

import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { MODAL_ACTION_HEIGHT } from '../constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmActionModal',
  props: {
    modalActive: { type: Boolean },
    title: {},
    confirmText: {},
    confirmClass: { default: 'bg-success' },
    loading: { type: Boolean, default: false }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalVue, {
    modalActive: _ctx.modalActive,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('close'))),
    maxWidth: "max-w-2xl"
  }, {
    header: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.title), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(OutlinedButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
          text: "Cancelar",
          width: "150px",
          height: _unref(MODAL_ACTION_HEIGHT),
          "data-testid": "confirm-action-cancel-button"
        }, null, 8, ["height"]),
        _createVNode(FilledButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm'))),
          text: _ctx.confirmText,
          width: "180px",
          height: _unref(MODAL_ACTION_HEIGHT),
          class: _normalizeClass(_ctx.confirmClass),
          loading: _ctx.loading,
          disabled: _ctx.loading,
          "data-testid": "confirm-action-confirm-button"
        }, null, 8, ["text", "height", "class", "loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["modalActive"]))
}
}

})